import React from 'react';

export const mapCaregiversCertifications = (professional) => {
	if (professional?.certifications?.length) {
		return professional?.certifications.map((certif) => {
			const certifSpecializations = professional.specialties
				?.filter(
					(spec) =>
						spec.resource_type_id === certif.resource_type_id ||
						(['CRT', 'RRT'].includes(certif.resource_type) && spec.code.startsWith('RT_'))
				)
				.sort((a, b) => a.label.localeCompare(b.label));
			const states = [...certif.states];
			states.sort((a, b) => a.code.localeCompare(b.code));
			return {
				...certif,
				states,
				specialties: certifSpecializations
			};
		});
	}
	return [{ resource_type: '-', specialties: [], states: [] }];
};

export const getProfessionalCityState = (professional) => {
	const address = [];
	if (professional.city_name) {
		address.push(professional.city_name);
	}

	if (professional.state_code) {
		address.push(professional.state_code);
	}

	if (!address.length) {
		return <span>-</span>;
	}
	return <h4>{address.join(', ')}</h4>;
};
